<template>
    <MainHeader/>
    <HeroSection/>
    <Events/>
    <Course/>
    <Blog/>
    <!-- <FreeEducation/> -->
    <Footer footerPadding="true"/>
</template>

<script>
import MainHeader from '../components/Home/Header.vue';
import HeroSection from '../components/Home/HeroSection.vue';
import Events from '../components/Home/Events.vue';
import Course from '../components/Home/Course.vue';
import Blog from '../components/Home/Blog.vue';
// import FreeEducation from '../components/Home/FreeEducation.vue';
import Footer from '../components/Home/Footer.vue';

export default {
    name:'HomePage',
    components:{
        MainHeader,
        HeroSection,
        Events,
        Course,
        Blog,
        // FreeEducation,
        Footer,
    }
}
</script>